<div class="fm-page">
  <div class="titlebar-area">
    <ng-content select="[fmTitlebar]"></ng-content>
  </div>
  <div class="content-area">
    <ng-content select="[fmContent]"></ng-content>
  </div>
</div>

